import { useTranslation } from "react-i18next";

export default function LangSwitch({ dark = false }) {
  const { i18n, t } = useTranslation();
  const current = i18n.language?.startsWith("en") ? "en" : "fr";
  const toggle = () => i18n.changeLanguage(current === "fr" ? "en" : "fr");
  const label = current === "fr" ? t("lang.switch_to_en") : t("lang.switch_to_fr");
  const baseCls = dark
    ? "border-slate-700 text-slate-300 hover:text-white hover:border-slate-500"
    : "border-slate-200 text-slate-600 hover:text-slate-900 hover:border-slate-400";
  return (
    <button
      onClick={toggle}
      data-testid="lang-switch"
      aria-label={label}
      title={label}
      className={`inline-flex items-center gap-1.5 text-[11px] tracking-[0.14em] uppercase font-semibold px-2.5 py-1.5 rounded-full border transition ${baseCls}`}
    >
      <span className={current === "fr" ? "opacity-100" : "opacity-40"}>FR</span>
      <span className={dark ? "text-slate-600" : "text-slate-300"}>·</span>
      <span className={current === "en" ? "opacity-100" : "opacity-40"}>EN</span>
    </button>
  );
}
